module.exports = __webpack_public_path__ + "static/img/song.38c9062.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/song.png
// module id = neYx
// module chunks = 6